import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';
import musicTitle from '../../asset/music/comeout.mp3'
import ParentInfo2 from '../../component/Info/ParentInfo2';


const LeeYeonSeo = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "연서 ♥ 지환";
    const openDesc = "결혼식에 초대합니다.";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/180/thumb2.jpeg";

    const lng = 128.533210876944;
    const lat = 35.8368668508677;

    const placeTelNum = "053-552-0500";

    const forCar = "대구 달서구 구마로 52 파라다이스컨벤션웨딩";
    const forParking = "파라다이스웨딩 지하주차장 (지하1층 - 2층)\n1시간 30분 무료 (이후 30분당 1000원)\n ·  외부 유료주차장 : 대구 달서구 와룡로 9길 37 \n(무제한 5,000원)\n\n※ 주차공간이 매우 혼잡하오니 가급적 대중교통 이용해 주세요.";
    const forPublic = " ·  지하철 이용 시\n2호선 두역 3번 출구에서 156버스 환승\n\n · 버스 이용 시\n564번, 156번 이용후 남대구 IC 하차";
    const forTrain2 = "·  동대구역\n지하철 1호선 서부정류장역 1번출구 건너 564 \n(남대구 IC 2 하차)\n또는 651 (본리네거리 하차)버스환승 혹은 택시 이용\n(10분 소요)\n\n·  서대구역\n급행 8 (학산공원 1 하차) 버스 이용 혹은 택시 이용 \n(8분 소요)"
    
    const parents = [
        {groom : "배권헌 · 김현주의 장남"},
        {bride : "이재하 · 김소윤의 장녀"}
    ] 

    const parentInfo = {
        groom: {
            dad: { name: "배권헌", isDeceased: false },
            mom: { name: "김현주", isDeceased: false },
            role: "장남",
        },
        bride: {
            dad: { name: "이재하", isDeceased: false },
            mom: { name: "김소윤", isDeceased: false },
            role: "장녀",
        }
    };

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // 블루A #9FB4E7
    // 연퍼플 #e4aced
    // 빈티지 연퍼플 #bf9cd8
    // 소라 : #88abd1
    // #edacb1
    // #D77599
    // #BC5078
    // #ff8faf
    // 레몬 옐로우 #EFD140
    // #EB9217
    // 빈티지 옐로우 : #EAC63C
    // #FC62A4
    // #f5408d
    // #ffb0d2 쿨 연핑크
    // 핑크A #FF8A83
    const conceptStyle = {
        // spring 핑크B
        concept: "SPRING",
        titleColor: "#ffb0d2",
        pointColor: "#ffb0d2",
        btnBgColor: "#ffcfe1",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fff5f9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "INVITATION";
    const msg1 = "가을에 태어나\n내내 겨울인 줄 알았던 신부가,\n여름에 태어난 신랑을 만나\n비로소 따뜻한 봄이 되었습니다.";
    const msg2 = "이제 우리는\n그 봄의 따스함을 엮어,\n사랑이 가득한 가정을 이루려 합니다"
    const msg3 = "부디 오셔서,\n저희의 첫걸음을 지켜봐 주시고,\n함께 축복해주세요."

    const groomAccountList = [
        {
            role: "신랑",
            name: "배지환",
            bank: "카카오뱅크",
            accountNumber : "3333-11-5270556",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FZGU7yjCy"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "배권헌",
        //     bank: "",
        //     accountNumber : "",
        //     isKakao : false
        // }
        ,{
            role: "신랑 모",
            name: "김현주",
            bank: "경남은행",
            accountNumber : "221-0018-1739-05",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "이연서",
            bank: "카카오뱅크",
            accountNumber : "3333-05-1164062",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FWH87vgUO"
        }
        ,{
            role: "신부 부",
            name: "이재하",
            bank: "농협은행",
            accountNumber : "351-1101-5814-33",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "김소윤",
            bank: "농협은행",
            accountNumber : "755052-51-075679",
            isKakao : false
        }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "배지환",
            call: "010-9954-8999"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "배권헌",
        //     call: ""
        // }
        ,{
            role: "신랑 모",
            name: "김현주",
            call: "010-8748-3285"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "이연서",
            call: "010-8270-1072"
        }
        ,{
            role: "신부 부",
            name: "이재하",
            call: "010-3534-5330"
        },
        {
            role: "신부 모",
            name: "김소윤",
            call: "010-4501-0823"
        }
    ]

    const interviewContent = [
        {
            question : "당신의 MBTI는?",
            groomAnswer: "INTP",
            brideAnswer: "ENTP"
        },
        {
            question : "서로의 첫인상은 어땠어?",
            groomAnswer: "멋있었다",
            brideAnswer: "무뚝뚝"
        },
        {
            question : "서로에 대해 다섯글자로 소개한다면?",
            groomAnswer: "사랑스러워",
            brideAnswer: "역사 박사"
        },
        {
            question : "결혼을 앞둔 소감은?!",
            groomAnswer: "살짝 긴장돼",
            brideAnswer: "실감이 안나"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "잘해줄게♥",
            brideAnswer: "행복하자♥"
        }
    ]

    const informationList =[
        {
            title : "♥신랑신부가 준비한 포토부스 이벤트♥",
            content : "10시30분-12시 운영합니다! \n많이 참여해주세요\n\n예쁜사진과 축하메시지를 남겨주시고,\n인생사진도 마음껏 가져가세요 :D"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#ffb0d2"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={70}>
                        <ParentInfo2 conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper>
                    <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forParking={forParking} forTrain2={forTrain2} forCar={forCar} forPublic={forPublic} conceptStyle={conceptStyle}/>
                    {/* <Information titleFontSize={"15px"} pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default LeeYeonSeo;